// --- 常量与变量 ---

const H5_LOCATION_NAV_LOADING_ROOT_ID = 'travel-h5-location-nav-loading-root'
const H5_LOCATION_NAV_LOADING_STYLE_ID = 'travel-h5-location-nav-loading-style'
/** location 未触发卸载时兜底关闭，避免蒙层长期挡住滚动 */
const H5_LOCATION_NAV_LOADING_FALLBACK_MS = 12000
/** 至少展示一段时间，避免 WebView 未绘制就 location 跳转 */
const H5_LOCATION_NAV_LOADING_MIN_VISIBLE_MS = 280

const H5_LOCATION_NAV_LOADING_STYLE_TEXT = `
#${H5_LOCATION_NAV_LOADING_ROOT_ID} {
  position: fixed;
  inset: 0;
  z-index: 10001;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding:
    env(safe-area-inset-top, 0px)
    env(safe-area-inset-right, 0px)
    env(safe-area-inset-bottom, 0px)
    env(safe-area-inset-left, 0px);
  background-color: #f3f5fa;
  touch-action: none;
}
#${H5_LOCATION_NAV_LOADING_ROOT_ID} .travel-h5-location-nav-loading__inner {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 6px;
  width: 70px;
  height: 36px;
}
#${H5_LOCATION_NAV_LOADING_ROOT_ID} .travel-h5-location-nav-loading__bar {
  width: 6px;
  height: 14px;
  border-radius: 999px;
  background: linear-gradient(180deg, #4b74e3 0%, #204abf 100%);
  box-shadow: 0 4px 8px rgba(32, 74, 191, 0.16);
  animation: travel-h5-location-nav-loading-wave 0.9s ease-in-out infinite;
  transform-origin: center bottom;
}
#${H5_LOCATION_NAV_LOADING_ROOT_ID} .travel-h5-location-nav-loading__text {
  margin-top: 10px;
  font-size: 12px;
  color: #8b95a8;
  letter-spacing: 0.08em;
}
@keyframes travel-h5-location-nav-loading-wave {
  0%, 100% {
    height: 14px;
    opacity: 0.45;
  }
  50% {
    height: 34px;
    opacity: 1;
  }
}
`

let h5LocationNavLoadingHideTimer = null
let h5LocationNavLoadingBodyOverflow = ''
let h5LocationNavLoadingPageShowBound = false
let h5LocationNavLoadingShownAt = 0

// --- 函数 ---

function ensureH5LocationNavLoadingDom() {
  if (typeof document === 'undefined') {
    return null
  }

  if (!document.getElementById(H5_LOCATION_NAV_LOADING_STYLE_ID)) {
    const styleEl = document.createElement('style')
    styleEl.id = H5_LOCATION_NAV_LOADING_STYLE_ID
    styleEl.textContent = H5_LOCATION_NAV_LOADING_STYLE_TEXT
    document.head.appendChild(styleEl)
  }

  let rootEl = document.getElementById(H5_LOCATION_NAV_LOADING_ROOT_ID)
  if (!rootEl) {
    rootEl = document.createElement('div')
    rootEl.id = H5_LOCATION_NAV_LOADING_ROOT_ID
    rootEl.setAttribute('aria-hidden', 'true')

    const innerEl = document.createElement('div')
    innerEl.className = 'travel-h5-location-nav-loading__inner'

    for (let barIndex = 1; barIndex <= 5; barIndex += 1) {
      const barEl = document.createElement('div')
      barEl.className = 'travel-h5-location-nav-loading__bar'
      barEl.style.animationDelay = `${(barIndex - 1) * 0.12}s`
      innerEl.appendChild(barEl)
    }

    const textEl = document.createElement('div')
    textEl.className = 'travel-h5-location-nav-loading__text'
    textEl.textContent = '加载中'

    rootEl.appendChild(innerEl)
    rootEl.appendChild(textEl)
    document.body.appendChild(rootEl)
  }

  return rootEl
}

/** H5 启动时预创建蒙层 DOM，避免首次外跳才插入导致来不及绘制 */
export function initH5LocationNavLoading() {
  // #ifdef H5
  ensureH5LocationNavLoadingDom()
  // #endif
}

function bindH5LocationNavLoadingPageShowOnce() {
  // #ifdef H5
  if (h5LocationNavLoadingPageShowBound || typeof window === 'undefined') {
    return
  }
  h5LocationNavLoadingPageShowBound = true
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      hideH5LocationNavLoadingSafe()
    }
  })
  // #endif
}

/** H5 外跳前展示全屏 loading（`navigateH5Location` 调用） */
export function showH5LocationNavLoading() {
  // #ifdef H5
  if (typeof document === 'undefined') {
    return
  }
  bindH5LocationNavLoadingPageShowOnce()
  if (h5LocationNavLoadingHideTimer) {
    clearTimeout(h5LocationNavLoadingHideTimer)
    h5LocationNavLoadingHideTimer = null
  }

  const rootEl = ensureH5LocationNavLoadingDom()
  if (!rootEl) {
    return
  }

  h5LocationNavLoadingBodyOverflow = document.body.style.overflow
  document.body.style.overflow = 'hidden'
  rootEl.style.display = 'flex'
  void rootEl.offsetHeight
  h5LocationNavLoadingShownAt = Date.now()
  // #endif
}

/** 关闭 H5 外跳 loading；重复调用安全 */
export function hideH5LocationNavLoadingSafe() {
  // #ifdef H5
  if (typeof document === 'undefined') {
    return
  }
  if (h5LocationNavLoadingHideTimer) {
    clearTimeout(h5LocationNavLoadingHideTimer)
    h5LocationNavLoadingHideTimer = null
  }

  const rootEl = document.getElementById(H5_LOCATION_NAV_LOADING_ROOT_ID)
  if (rootEl) {
    rootEl.style.display = 'none'
  }
  document.body.style.overflow = h5LocationNavLoadingBodyOverflow
  // #endif
}

/** 极少数 location 未卸载时的兜底关闭 */
export function scheduleH5LocationNavLoadingFallbackHide() {
  // #ifdef H5
  if (h5LocationNavLoadingHideTimer) {
    clearTimeout(h5LocationNavLoadingHideTimer)
  }
  h5LocationNavLoadingHideTimer = window.setTimeout(() => {
    hideH5LocationNavLoadingSafe()
  }, H5_LOCATION_NAV_LOADING_FALLBACK_MS)
  // #endif
}

/** 等待 loading 绘制完成后再外跳 */
export function awaitH5LocationNavLoadingPaint() {
  // #ifdef H5
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const elapsed = Date.now() - h5LocationNavLoadingShownAt
        const remainMs = Math.max(0, H5_LOCATION_NAV_LOADING_MIN_VISIBLE_MS - elapsed)
        if (remainMs === 0) {
          resolve()
          return
        }
        window.setTimeout(resolve, remainMs)
      })
    })
  })
  // #endif
  // #ifndef H5
  return Promise.resolve()
  // #endif
}
